import { Settings, ILegalResponse } from '../models';
import { getRequest } from './httpService';

export const getSettings = async (): Promise<Settings> => {
  const content = await getRequest(`${process.env.VUE_APP_API_DOMAIN}/api/system/settings/ivr`) as Settings;
  return content;
};

export const getLegalSettings = async (brand: string): Promise<ILegalResponse> => {
  const legalSettings = await getRequest(`${process.env.VUE_APP_API_DOMAIN}/api/system/settings/legal`, { 'x-titan-web-brand': brand }) as ILegalResponse;
  return legalSettings;
};

export const getEulaPpHtml = async (htmlContentType: string, platform: string, brand: string, version: string): Promise<string> => {
  const url = `${process.env.VUE_APP_API_DOMAIN}/api/system/htmlcontent?htmlContentType=${htmlContentType}&platform=${platform}&version=${version}`;
  const response = await getRequest(url, { 'x-titan-web-brand': brand }) as any;
  return response;
};
